export enum BetSlipActions {
    Validate = 0,
    Submit = 1,
    Test = 2,
    SendRequest = 3,
    Approved = 4
};